/**
 * created by mgg
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';

export default class XXX extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <div style={{padding:20}}>

            </div>
        )
    }
}
